import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";


interface User {
  id: number;
}

interface Question {
  id: number;
}

interface Reaction {
  id: number;
  code: string;
  name: string;
}

interface SentimentScore {
  positive: number;
  neutral: number;
  negative: number;
  total: number;
}

interface Comment {
  id: number;
  user: User;
  question: Question;
  body: string;
  createOn: string;
  sentimentScore: SentimentScore;
  reactions: {
    reaction: Reaction;
    value: number;
  }[];
  reactionScore: number;
}

interface CommentsSlice {
  isLoading: boolean;
  negativeReactedComments: Comment[];
  error: string;
}

const initialState: CommentsSlice = {
  isLoading: false,
  negativeReactedComments: [],
  error: "",
};

export const getReactedNegativeComments = createAsyncThunk(
  "getReactedNegativeComments",
  async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/reports/boards/${id}/reaction/negative-comments`
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const reactedNegativeCommentsSlice = createSlice({
  initialState,
  name: "board",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReactedNegativeComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReactedNegativeComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.negativeReactedComments = action.payload;
      })
      .addCase(getReactedNegativeComments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
